import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { UpdateFinanceTradesAdditionsRequestModel, UpdateFinanceTradesAdditionsResponseModel } from "@/features/accounts/finance/services/update-trades-additions-model";

export class UpdateFinanceTradesAdditionsApi {
  /**
   * 銀行明細メモ・無効明細更新API
   */
  public updateFinanceTradesAdditions = async (
    param: UpdateFinanceTradesAdditionsRequestModel
  ): Promise<UpdateFinanceTradesAdditionsResponseModel> => {
    const path = `/api/financeaccounts/finances/tradesadditions`;
    const res = await ApiClient.instance.put<UpdateFinanceTradesAdditionsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
